import types from "../types/types";
const initialState = {
	wages: undefined,
};

const wagesReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case types.SET_WAGES:
			return {
				...state,
				wages: payload,
			};
		default:
			return state;
	}
};
export default wagesReducer;
